import { render, staticRenderFns } from "./RuleBenefitReportModal.vue?vue&type=template&id=7fd47a3c&scoped=true"
import script from "./RuleBenefitReportModal.vue?vue&type=script&lang=js"
export * from "./RuleBenefitReportModal.vue?vue&type=script&lang=js"
import style0 from "./RuleBenefitReportModal.vue?vue&type=style&index=0&id=7fd47a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd47a3c",
  null
  
)

export default component.exports